import { createContext, useContext, useState } from "react";

const NotesModalContext = createContext();

export function NotesModalProvider({ children }) {
  const [open, setOpen] = useState(false);

  return (
    <NotesModalContext.Provider value={{ open, setOpen }}>
      {children}
    </NotesModalContext.Provider>
  );
}

export const useNotesModal = () => useContext(NotesModalContext);
